export const TYPE_OPTS = ['default', 'secondary'];

export const dispatchClassName = ({ value, disabled, type } = {}) => {
  if (disabled) {
    return {
      background: 'bg-disabled',
      border: 'border-default',
    };
  }

  if (value) {
    const dispatchType = {
      default: {
        background: 'bg-brand-primary-base',
        border: 'border-transparent',
      },
      secondary: {
        background: 'bg-brand-secondary-base',
        border: 'border-transparent',
      },
    };

    return dispatchType?.[type];
  }

  return {
    background: 'bg-light',
    border: 'border-default',
  };
};

export const renderCheck = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M9 6H3"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const renderMinus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M2.5 6.5L4.5 8.5L9.5 3.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
